export const heroSlides = [
  {
    id: "hero-dark-river",
    filmId: "dark-river",
    kicker: "本周焦点 · 剧集",
    title: "暗河",
    description: "一条河吞掉了十七年的秘密。国产悬疑新标杆，豆瓣开分 9.1，全 36 集已完结。",
    meta: "2026 · 中国大陆 · 悬疑 / 犯罪",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20foggy%20industrial%20river%20at%20dawn%20with%20old%20bridges%20cranes%20and%20a%20small%20boat%20trailing%20a%20wake%20deep%20navy%20blue%20mist%20with%20warm%20amber%20street%20lights%20reflecting%20on%20water%20quiet%20tense%20atmosphere%20no%20text%20high%20detail&width=1600&height=900&seq=rs-hero-darkriver&orientation=landscape",
  },
  {
    id: "hero-deepsea",
    filmId: "deep-sea-echo",
    kicker: "新片上线 · 电影",
    title: "深海回声",
    description: "当沉默比深海更冷，两代人的秘密被一起打捞上岸。年度最值得在大银幕观看的华语悬疑。",
    meta: "2026 · 中国大陆 · 剧情 / 悬疑",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20underwater%20scene%20with%20deep%20dark%20ocean%20water%20pale%20shafts%20of%20light%20from%20the%20surface%20and%20floating%20particles%20a%20tiny%20diver%20silhouette%20in%20the%20distance%20muted%20deep%20navy%20and%20amber%20palette%20atmospheric%20abstract%20no%20text%20high%20detail&width=1600&height=900&seq=rs-hero-deepsea&orientation=landscape",
  },
  {
    id: "hero-changan",
    filmId: "changan-wind",
    kicker: "热门电影 · 古装",
    title: "风起长安",
    description: "一封没有署名的密诏，让整座长安城的风向都变了。实拍打戏与东方美学的一次回归。",
    meta: "2025 · 中国大陆 · 古装 / 动作",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20ancient%20chinese%20capital%20city%20at%20dusk%20with%20layered%20rooftops%20glowing%20lanterns%20and%20mist%20over%20distant%20mountains%20deep%20navy%20blue%20sky%20with%20warm%20amber%20lantern%20light%20painterly%20epic%20atmosphere%20no%20text%20high%20detail&width=1600&height=900&seq=rs-hero-changan&orientation=landscape",
  },
  {
    id: "hero-oldstreet",
    filmId: "old-street",
    kicker: "口碑剧集 · 年代",
    title: "长街旧梦",
    description: "一条街的三十年，装得下三代人的悲喜。不靠强情节推进的年代群像，评分 8.9。",
    meta: "2024 · 中国大陆 · 年代 / 家庭",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20view%20of%20a%20narrow%20old%20chinese%20neighborhood%20street%20in%20the%201980s%20with%20wooden%20shop%20fronts%20bicycles%20laundry%20lines%20and%20warm%20evening%20sunlight%20haze%20deep%20navy%20shadows%20with%20amber%20highlights%20nostalgic%20film%20texture%20no%20text%20high%20detail&width=1600&height=900&seq=rs-hero-oldstreet&orientation=landscape",
  },
  {
    id: "hero-iron",
    filmId: "under-iron",
    kicker: "影展佳作 · 历史",
    title: "铁幕之下",
    description: "一堵墙升起之前，两个家庭已经先被分开了。战后欧洲最克制的一次家庭叙事。",
    meta: "2025 · 德国 · 历史 / 战争",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20divided%20european%20city%20street%20in%20cold%20morning%20fog%20with%20concrete%20barriers%20and%20old%20apartment%20facades%20desaturated%20deep%20navy%20tones%20with%20warm%20amber%20window%20lights%20historical%20drama%20atmosphere%20no%20text%20high%20detail&width=1600&height=900&seq=rs-hero-iron&orientation=landscape",
  },
];